import { useMediaQuery } from '@chakra-ui/react'
import { DESKTOP_BREAKPOINT } from '../../../constants'

export function useIsDesktopNav(): boolean {
  const [isDesktop] = useMediaQuery(`(min-width: ${DESKTOP_BREAKPOINT})`)
  return isDesktop
}
